import { SVGIconProps } from '../types/svg';

export const Permis = (props: SVGIconProps) => (
  <svg
    width={50}
    height={51}
    viewBox="0 0 50 51"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.6013 30.7991L43.9742 11.3121C43.8266 10.2174 42.8196 9.44967 41.7249 9.59724L5.99145 14.4147C4.89678 14.5623 4.12901 15.5693 4.27659 16.664L6.90375 36.151C7.05133 37.2457 8.05837 38.0134 9.15303 37.8659L44.8865 33.0484C45.9812 32.9008 46.7489 31.8938 46.6013 30.7991ZM44.9652 11.1785L47.5924 30.6655C47.8137 32.3075 46.6621 33.8181 45.0201 34.0395L9.28664 38.8569C7.64464 39.0783 6.13408 37.9266 5.91272 36.2846L3.28556 16.7976C3.06419 15.1556 4.21584 13.645 5.85784 13.4236L41.5913 8.60621C43.2333 8.38484 44.7438 9.53649 44.9652 11.1785Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9419 30.0168L42.5811 12.5058C42.4704 11.6848 41.7151 11.109 40.8941 11.2197L7.22227 15.7592C6.40127 15.8699 5.82545 16.6251 5.93613 17.4461L8.29689 34.9572C8.40758 35.7782 9.16286 36.354 9.98386 36.2433L43.6557 31.7038C44.4767 31.5931 45.0525 30.8378 44.9419 30.0168ZM43.0766 12.439L45.4374 29.95C45.5849 31.0447 44.8172 32.0517 43.7225 32.1993L10.0507 36.7388C8.95599 36.8864 7.94895 36.1186 7.80138 35.024L5.44061 17.513C5.29304 16.4183 6.0608 15.4112 7.15547 15.2637L40.8273 10.7242C41.922 10.5766 42.929 11.3444 43.0766 12.439Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3218 21.0402C18.1457 19.7341 16.9442 18.8181 15.6382 18.9942C14.3322 19.1703 13.4161 20.3718 13.5922 21.6778C13.7683 22.9838 14.9698 23.8998 16.2758 23.7238C17.5818 23.5477 18.4979 22.3462 18.3218 21.0402ZM15.5046 18.0032C17.3579 17.7533 19.063 19.0532 19.3128 20.9066C19.5627 22.7599 18.2628 24.4649 16.4094 24.7148C14.5561 24.9647 12.851 23.6648 12.6012 21.8114C12.3513 19.958 13.6512 18.253 15.5046 18.0032ZM19.8737 25.5685C20.8041 25.4431 21.7455 25.6986 22.4909 26.2761C23.2359 26.8535 23.7241 27.7052 23.8506 28.6433L24.0563 30.1688C24.0932 30.4425 23.9012 30.6942 23.6276 30.7311C23.3539 30.768 23.1021 30.5761 23.0652 30.3024L22.8596 28.7769C22.7679 28.0967 22.414 27.4817 21.8783 27.0666C21.3429 26.6516 20.6698 26.4702 20.0073 26.5595L14.0006 27.3693C13.3381 27.4587 12.7371 27.8118 12.3306 28.3537C11.924 28.8959 11.7456 29.5826 11.8373 30.2629L12.043 31.7884C12.0799 32.0621 11.888 32.3138 11.6143 32.3507C11.3406 32.3876 11.0889 32.1957 11.052 31.922L10.8463 30.3965C10.7198 29.4584 10.9651 28.5077 11.5306 27.7537C12.0964 26.9994 12.9365 26.5037 13.867 26.3783L19.8737 25.5685Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9613 18.6275C25.9244 18.3538 26.1164 18.102 26.39 18.0652L36.8714 16.6521C37.145 16.6152 37.3968 16.8072 37.4337 17.0808C37.4706 17.3545 37.2786 17.6062 37.005 17.6431L26.5237 19.0562C26.25 19.0931 25.9982 18.9011 25.9613 18.6275Z"
      fill="#FF8A02"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.53 22.8459C26.4931 22.5722 26.6851 22.3204 26.9587 22.2835L32.1994 21.577C32.4731 21.5401 32.7248 21.7321 32.7617 22.0057C32.7986 22.2794 32.6067 22.5312 32.333 22.568L27.0924 23.2746C26.8187 23.3115 26.5669 23.1195 26.53 22.8459Z"
      fill="#FF8A02"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.0669 26.8278C27.03 26.5541 27.2219 26.3024 27.4956 26.2655L36.0768 25.1086C36.3505 25.0717 36.6022 25.2636 36.6391 25.5373C36.676 25.811 36.4841 26.0627 36.2104 26.0996L27.6292 27.2565C27.3555 27.2934 27.1038 27.1015 27.0669 26.8278Z"
      fill="#FF8A02"
    />
  </svg>
);
